<section class="insight-queries-chart-legend" [class.modal-view]="isModalView()">
  @for (item of legends(); track $index) {
    <div
      class="insight-queries-chart-legend__item"
      [class.active]="item.active"
      (click)="onLegendClick(item, $index)"
      [matTooltip]="item.label"
      matTooltipPosition="above">
      <span class="color-box" [style.background-color]="item.color"></span>
      <p>{{ item.label }}</p>
    </div>
  }

  @if (showMoreBtn()) {
    <div>
      <button type="button" class="show-more-btn" (click)="onShowMoreClick()">… show more</button>
    </div>
  }
</section>

<app-generic-chart
  [data]="data"
  [presentationType]="presentationType"
  [chartConfiguration]="chartConfiguration"
  [options]="insightOptions()"/>

